<template>
  <div class="item">
    <div class="flex justify-center ">
      <span :class="bgColor" class="item__number">
        <span class="item__number-main">{{ item.number }}</span>
        <span class="item__number-shadow">{{ item.number }}</span>
      </span>
    </div>
    <div class="item__card">
      <div class="item__card-title">
        <span>{{ item.title }}</span>
      </div>
      <div class="item__card-description">
        {{ item.description }}
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'HowItWork',
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
    }
  },
  computed: {
    bgColor () {
      return `bg-${this.item.bgColor}`
    }
  }
}
</script>
<style scoped lang="scss">
.item {
    @apply w-auto px-4 lg:px-0 lg:w-96 mx-auto lg:mr-4 mb-4;
    &__number {
        @apply text__headline-3-md--bold rounded-lg py-[10px] px-4 mb-[-10px] relative;
        &-main {
            @apply text-white relative z-10;
        }
        &-shadow {
            @apply text-title absolute top-[10.5px] left-[17px];
        }
    }
    &__card {
        @apply pb-4 lg:p-6 border border-primary-100 rounded-lg text-center;
        &-title {
            @apply pt-4 pb-2 text-body-1 text__body-1-md--bold
        }
        &-description {
            @apply pb-4 px-4 lg:px-0 text-body-2 text__body-2-md--regular text__caption-xs--regular
        }
    }
}
</style>
